<div class="modal-header">
  <h5 class="modal-title">Rechazar recepción</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="cancelar()"></button>
</div>

<div class="modal-body" [formGroup]="form">
  <div class="mb-2">
    <div><strong>Remito:</strong> {{ remito?.prefijo }}-{{ remito?.numeroRemito }}</div>
    <div><strong>Terminal:</strong> {{ remito?.codigoTerminal }} • <strong>Aeroplanta:</strong> {{ remito?.codigoAeroplanta }}</div>
  </div>

 <div class="mb-3">
      <label for="motivo" class="form-label">Motivo</label>
      <select id="motivo" formControlName="motivo" class="form-select">
        <option value="" disabled selected>Seleccione un motivo</option>
        <option *ngFor="let m of motivos" [value]="m.value">{{ m.label }}</option>
      </select>
    </div>

  <div class="mb-3">
    <label for="detalle" class="form-label fw-bold">Detalle (opcional)</label>
    <textarea id="detalle" formControlName="detalle" class="form-control" rows="4"
      placeholder="Ingrese detalles adicionales del rechazo..."></textarea>
  </div>
</div>

<div class="modal-footer">
  <button class="btn btn-outline-secondary" [disabled]="cargandoRechazo" (click)="cancelar()">Cancelar</button>
  <button class="btn btn-danger" [disabled]="form.invalid || cargandoRechazo" (click)="confirmar()">@if(!cargandoRechazo) { Confirmar rechazo } @else { Cargando... }</button>
</div>
